import { render, staticRenderFns } from "./ContactList.vue?vue&type=template&id=1a448c54"
import script from "./ContactList.vue?vue&type=script&lang=js"
export * from "./ContactList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a448c54')) {
      api.createRecord('1a448c54', component.options)
    } else {
      api.reload('1a448c54', component.options)
    }
    module.hot.accept("./ContactList.vue?vue&type=template&id=1a448c54", function () {
      api.rerender('1a448c54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/ContactList.vue"
export default component.exports